/** Shared labels for /custom-jewelry form and admin bespoke inbox. */

import { mergeCustomJewelryConfig } from '../content/siteCopyHelpers';
import {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_JEWELRY_TYPE_LEGACY,
  BESPOKE_OCCASION_DEFAULTS,
} from './bespokeFormOptionDefaults';

export {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_JEWELRY_TYPE_LEGACY,
  BESPOKE_OCCASION_DEFAULTS,
} from './bespokeFormOptionDefaults';

/** @deprecated use resolveBespokeOccasions(storeCopy) */
export const BESPOKE_OCCASIONS = BESPOKE_OCCASION_DEFAULTS;

/** @deprecated use resolveBespokeJewelryTypes(storeCopy) */
export const BESPOKE_JEWELRY_TYPES = BESPOKE_JEWELRY_TYPE_DEFAULTS;

const BESPOKE_JEWELRY_TYPE_ALL_DEFAULTS = [...BESPOKE_JEWELRY_TYPE_DEFAULTS, ...BESPOKE_JEWELRY_TYPE_LEGACY];

export const BESPOKE_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

/** @param {object} [storeCopy] settings.store_copy */
export function resolveBespokeOccasions(storeCopy) {
  return mergeCustomJewelryConfig(storeCopy?.custom_jewelry).occasions;
}

/** @param {object} [storeCopy] settings.store_copy */
export function resolveBespokeJewelryTypes(storeCopy) {
  return mergeCustomJewelryConfig(storeCopy?.custom_jewelry).jewelry_types;
}

/** @param {object} [storeCopy] settings.store_copy */
function jewelryTypesWithLegacy(storeCopy) {
  return [...resolveBespokeJewelryTypes(storeCopy), ...BESPOKE_JEWELRY_TYPE_LEGACY];
}

/** @param {string} value @param {{ value: string, label: string }[]} options */
export function bespokeOptionLabel(value, options) {
  const hit = options.find((o) => o.value === value);
  return hit?.label || value || '—';
}

/** @param {string} value @param {object} [storeCopy] settings.store_copy */
export function bespokeOccasionLabel(value, storeCopy) {
  const options = storeCopy ? resolveBespokeOccasions(storeCopy) : BESPOKE_OCCASION_DEFAULTS;
  return bespokeOptionLabel(value, options);
}

/** @param {string} value @param {object} [storeCopy] settings.store_copy */
export function bespokeJewelryTypeLabel(value, storeCopy) {
  const options = storeCopy ? jewelryTypesWithLegacy(storeCopy) : BESPOKE_JEWELRY_TYPE_ALL_DEFAULTS;
  return bespokeOptionLabel(value, options);
}

/** Comma-separated slugs from multi-select — e.g. "necklace,earrings,tikka". */
/** @param {string} value @param {object} [storeCopy] settings.store_copy */
export function bespokeJewelryTypesLabel(value, storeCopy) {
  const raw = String(value || '').trim();
  if (!raw) return '—';
  const options = storeCopy ? jewelryTypesWithLegacy(storeCopy) : BESPOKE_JEWELRY_TYPE_ALL_DEFAULTS;
  if (!raw.includes(',')) return bespokeOptionLabel(raw, options);
  return raw
    .split(',')
    .map((part) => bespokeOptionLabel(part.trim(), options))
    .filter(Boolean)
    .join(', ');
}

export function bespokeStatusLabel(value) {
  return bespokeOptionLabel(value, BESPOKE_STATUSES);
}

/** Customer-facing status labels (My account). */
export function bespokeCustomerStatusLabel(value) {
  const key = String(value || '').trim().toLowerCase();
  const map = {
    new: 'Request received',
    contacted: 'We contacted you',
    quoted: 'Quote sent',
    in_progress: 'In progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
  };
  return map[key] || bespokeStatusLabel(value);
}

export function bespokeCustomerStatusHint(value) {
  const key = String(value || '').trim().toLowerCase();
  const map = {
    new: 'Our studio will review your photos and reply with ideas and a quote.',
    contacted: 'Check your WhatsApp or email — we have reached out about your design.',
    quoted: 'We sent a quote — reply on WhatsApp or email to confirm or ask questions.',
    in_progress: 'Your custom piece is being handcrafted in our studio.',
    completed: 'This custom design request is complete.',
    cancelled: 'This request was closed. Contact us if you still need help.',
  };
  return map[key] || '';
}
